import React from "react";
import "../../../reusableComponents/SuccessModal/SuccessModal.scss";
import successIcon from "../../../assets/icons/AuthSuccessIcons.svg";
import CloseBtn from "../../../assets/icons/ClosebuttonModal.svg";
function SuccessModal({setModalOpen, title, desc, btnText}) {
  const [isClosing, setIsClosing] = React.useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      if (setModalOpen) setModalOpen(false);
    }, 400);
  };

  return (
    <div className="success_modal_overlay" onClick={handleClose}>
      <div
        className={`success_modal_container successPopupContainer ${
          isClosing ? "closing" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popupIcon">
          <img
            src={successIcon}
            alt="successful tick"
          />
        </div>

        <div className="titleDesc">
          <h1>{typeof title === "string" ? title : "Successful!"}</h1>
          <p>{typeof desc === "string" ? desc : "Everything went great. Let’s continue"}</p>
        </div>

        <div className="actionArea">
          <button
            className="success_modal_close_btn"
            onClick={handleClose}
          >
            {btnText || "Continue"}
          </button>
          <img
            src={CloseBtn}
            alt="Close Button"
            onClick={handleClose}
            className="closeBtnSect"
          />
        </div>
      </div>
    </div>
  );
}

export default SuccessModal;
